import { createFileRoute } from '@tanstack/react-router';
import { HoursPage } from '../features/hours/HoursPage';
import { validateMonthSearch } from '../lib/months';

export const Route = createFileRoute('/hours')({
  validateSearch: validateMonthSearch,
  component: HoursPage,
});
